import {Component, Input, OnInit} from '@angular/core';
import {Project} from "../../models/project";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ProjectService} from "../../services/project/project.service";
import {isNull} from "util";
import {MessagesService} from "../../services/messages/messages.service";

@Component({
    selector: 'app-project-modal',
    templateUrl: './project-modal.component.html',
    styleUrls: ['./project-modal.component.scss']
})
export class ProjectModal implements OnInit {

    @Input() project: Project;

    projectForm: FormGroup;
    projectFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private projectService: ProjectService,
        private messagesService: MessagesService,
    ) {
    }

    ngOnInit() {
        this.projectForm = this.formBuilder.group({
            name: [this.project ? this.project["name"] : '', [Validators.required]],
        });
    }

    submitProjectForm() {
        this.projectFormIsSubmitted = true;

        if (this.projectForm.invalid) {
            return;
        }

        return isNull(this.project)
            ? this.projectService.postProject(this.projectForm.get('name').value)
                .subscribe(
                    () => this.messagesService.successToast('Location Created'),
                    err => this.messagesService.errorToast(err),
                    () => this.activeModal.close(true)
                )
            :
            this.projectService.patchProject(this.project._id, this.projectForm.get('name').value)
                .subscribe(
                    () => this.messagesService.successToast('Location Updated'),
                    err => this.messagesService.errorToast(err),
                    () => this.activeModal.close(true)
                )
            ;
    }
}
